import { EventsViewSwitcher } from './EventsViewSwitcher';

export default EventsViewSwitcher;
